import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import { IconButton } from "@mui/material";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FolderIcon from "@mui/icons-material/Folder";
import { BsBox } from 'react-icons/bs';
import { OutlinedInput, StepLabel } from '@mui/material';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { useMerchantSignupMutation } from 'api/caterer';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router';


const steps = ['Merchant Registration', 'Owner Information'];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
      //   backgroundImage:
      //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
      backgroundColor: "#2B817B"
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
      //   backgroundImage:
      //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
      backgroundColor: "#2B817B"
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      width: {lg: "212.15px", md: "212.15px", sm: "150px", xs: "100%"},
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#9EA3AE',
      borderRadius: 1,
    },
  }));
  
  const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#9EA3AE',
    zIndex: 1,
    color: '#fff',
    width: 56,
    height: 56,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
      // backgroundImage:
      //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      backgroundColor: "#2B817B",
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      
    }),
    ...(ownerState.completed && {
      // backgroundImage:
      //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      backgroundColor: "#2B817B"
      
    }),
  }));
  
  function ColorlibStepIcon(props) {
    const { active, completed, className } = props;
  
    const icons = {
      1: <StorefrontIcon />,
      2: <PersonOutlineOutlinedIcon />,
    };
  
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }
  
  ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
  };
  

export default function MerchantRegStepper({setheightPropFunc}) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const navigate = useNavigate()
  const [userData, setUserData] = useState({});
  const [certifacteFile, setcertifacteFile] = useState(null)
  const [ getCatererSignUp , {isLoading}] = useMerchantSignupMutation()


  const handleCertifacateFileChange = (e) => {
    const file = e.target.files[0]
    setcertifacteFile(file)
    setUserData({...userData, certificate: certifacteFile })
  }


  const SubmitCaterer = () => {
    console.log(userData)
    const formData = new FormData();
    formData.append("merchantName", userData.merchantName);
    formData.append("address", userData.address);
    formData.append("certificate", userData.certificate);
    // formData.append("licence", userData.licence);
    formData.append("idCard", userData.idCard);
    formData.append("ownerName", userData.ownerName);
    formData.append("email", userData.email);
    formData.append("phone", userData.code+userData.phone);
    formData.append("pin", userData.pin);
    formData.append("password", userData.password);
    console.log("FormData", userData.name)
    getCatererSignUp(formData).then((res) => {
      console.log(res)
      if(res.error){
        console.log(res?.error?.data?.message)
        return Swal.fire("Failed!!", res?.error?.data?.message)
      }else{
        return Swal.fire("Caterer Signed Up SuccessFully"), navigate("/")
      }
      
    })
  }

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setUserData({})
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
    activeStep === 0 ? setheightPropFunc('1000px') : setheightPropFunc('800px')
    console.log("CheckStepperStatus",activeStep)
  };


  return (
    <Box sx={{ width: '100%', mt:'30px' }}>
      <Stepper connector={<ColorlibConnector />} alternativeLabel activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} 
             sx={{
            '& .MuiStepLabel-root .Mui-completed': {
              color: 'secondary.dark', // circle color (COMPLETED)
            },
            '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
              {
                color: "#2B817B", // Just text label (COMPLETED)
              },
            '& .MuiStepLabel-root .Mui-active': {
              color: 'secondary.main', // circle color (ACTIVE)
            },
            '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
              {
                color: "#2B817B", // Just text label (ACTIVE)
              },
            '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
              fill: 'black', // circle's number (ACTIVE)
            },
          }}
          >
            <StepLabel StepIconComponent={ColorlibStepIcon} onClick={handleStep(index)}
                sx={{cursor:'pointer'}}
            >
                {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
       
          <React.Fragment>
           
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
             
              <Box sx={{ flex: '1 1 auto' }} />
              </Box>
            <Box sx={{ mt: 2, mb: 1, py: 1 }}>
             {activeStep === 0 &&<Box>
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Merchant Name</Typography>
                <OutlinedInput onChange={(e) => setUserData({...userData , merchantName: e.target.value}) } placeholder="Enter your merchant name" sx={{ boxSizing: 'border-box', padding: '15px', width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', marginTop: 1 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Address</Typography>
                <OutlinedInput  onChange={(e) => setUserData({...userData , address: e.target.value}) } placeholder="Enter your address" sx={{ boxSizing: 'border-box', padding: '15px', width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', marginTop: 1 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Certification</Typography>
                <IconButton
                  disableRipple={true}
                  sx={{
                    boxSizing:"border-box",
                    padding: '15px',
                    marginTop: 1,
                    width: "100%",
                    background: "#F6F6F6",
                    height: "56px",
                    border: "1px solid #E1E1E6",
                    borderRadius: "6px",
                  }}
                  aria-label="upload picture"
                  component="label"
                >
                  <input
                    hidden
                    accept="image/*"
                    id="businessLicense"
                    name="businessLicense"
                    label="businessLicense"
                    type="file"
                    onChange={handleCertifacateFileChange}
                  />
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontSize: "16px", paddingTop: "4.5px" }}>
                        {/* Add File */}
                        {certifacteFile ? certifacteFile.name : "Add File"}
                      </Typography>
                    </Box>
                    <Box>
                      <FolderIcon  sx={{ fontSize: "25px", marginTop: "4.5px" }} />
                    </Box>
                  </Box>
                </IconButton>
                {/* <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Certification</Typography>
                <OutlinedInput  onChange={(e) => setUserData({...userData , certificate: e.target.value}) } placeholder="Upload your certification" sx={{ boxSizing: 'border-box', padding: '15px', width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', marginTop: 1 }} /> */}
                {/* <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', fontSize: '20px', lineHeight: '140%', color: '#1A1824', letterSpacing: '0.015em', marginTop: 1 }}>Bussiness Licence</Typography>
                <OutlinedInput  onChange={(e) => setUserData({...userData , bussinessLicence: e.target.value}) } placeholder="Upload your certification" sx={{ boxSizing: 'border-box', padding: '15px', width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', marginTop: 1 }} /> */}
                {/* <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '16px', lineHeight: '160%', letterSpacing: '0.015em', color: '#545359', marginTop: 1 }}>By procceeding. I Agree to Uber’s Terms of Use and acknowledge that i have read the Privacy Policy</Typography> */}
                <Button  
                    onClick={()=>{setheightPropFunc('1000px');handleNext();}} 
                    variant="contained"
                    size="large"
                    sx={{
                        width:'100%',
                        mt:'43px'
                    }}
                >
                    Continue
                </Button>
              </Box>}
                {activeStep === 1 && <Box>
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', letterSpacing: '0.015rem', fontSize: '20px', lineHeight: '140%', color: '#1A1824', marginBottom: 1 }}>ID card number</Typography>
                <OutlinedInput onChange={(e) => setUserData({...userData , idCard: e.target.value}) } placeholder="Enter your Id card" sx={{ width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', padding: '15px', marginBottom: 1 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', letterSpacing: '0.015rem', fontSize: '20px', lineHeight: '140%', color: '#1A1824', marginBottom: 1 }}>Owner name</Typography>
                <OutlinedInput onChange={(e) => setUserData({...userData , ownerName: e.target.value}) } placeholder="Enter your owner name" sx={{ width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', padding: '15px', marginBottom: 1 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', letterSpacing: '0.015rem', fontSize: '20px', lineHeight: '140%', color: '#1A1824', marginBottom: 1 }}>Email address</Typography>
                <OutlinedInput onChange={(e) => setUserData({...userData , email: e.target.value}) } placeholder="Enter your email address" sx={{ width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', padding: '15px', marginBottom: 1 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', letterSpacing: '0.015rem', fontSize: '20px', lineHeight: '140%', color: '#1A1824', marginBottom: 1 }}>Password</Typography>
                <OutlinedInput onChange={(e) => setUserData({...userData , password: e.target.value}) } placeholder="Enter your Your Password" sx={{ width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', padding: '15px', marginBottom: 1 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontWeight: '200', fontSize: '15px', lineHeight: '130%', letterSpacing: '0.015em', color: '#545359', marginBottom:"7px"}}>Password Must Contain At Least 8 Letters, One Uppercase Letter, One Lowercase Letter, One Number And One Special Character.</Typography>
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', letterSpacing: '0.015rem', fontSize: '20px', lineHeight: '140%', color: '#1A1824', marginBottom: 1 }}>Phone number</Typography>
                <OutlinedInput onChange={(e) => setUserData({...userData , phone: e.target.value}) } placeholder="+1000 000 000" sx={{ width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', padding: '15px', marginBottom: 2 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontStyle: 'normal', fontWeight: '500', letterSpacing: '0.015rem', fontSize: '20px', lineHeight: '140%', color: '#1A1824', marginBottom: 1 }}>Set Pin</Typography>
                <OutlinedInput onChange={(e) => setUserData({...userData , pin: e.target.value}) } placeholder="x-x-x-x" sx={{ width: '100%', height: '56px', border: '1px solid #E1E1E6', borderRadius: '4px', padding: '15px', marginBottom: 2 }} />
                <Typography sx={{ fontFamily: 'Outfit', fontWeight: '400', fontSize: '16px', lineHeight: '160%', color: '#545359' }}> By procceeding. I Agree to Uber’s Terms of Use and acknowledge that i have read the Privacy Policy</Typography>
                <Button
                  onClick={SubmitCaterer}
                    variant="contained"
                    size="large"
                    sx={{
                        width:'100%',
                        mt:'20px'
                    }}
                >
                    Continue
                </Button>
              </Box>}
            </Box>
          </React.Fragment>
      </div>
    </Box>
  );
}